import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useStore } from '@store';
import { Layout } from '@components';
import Info from '@assets/images/ai1.png';
import styles from './index.module.scss';

const { Header } = Layout;
const DashboardHeader = () => {
  const [pageTitle, setPageTitle] = useState<string>('');
  const { dashboardTitle } = useStore();

  useEffect(() => {
    setPageTitle(dashboardTitle);
  }, [dashboardTitle]);

  return (
    <Header className={styles['header']}>
      <div className={styles['hello']}>
        <h2 className="title text-purple">{pageTitle}</h2>
      </div>
      <div className={styles['info']}>
        <Link to="#">
          <img src={Info} alt="Info Image" className={styles['info_img']} />
        </Link>
      </div>
    </Header>
  );
};

export default DashboardHeader;
